import styled from 'styled-components';

export const TagsContainer = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px 0;
  height: 50px;

  li {
    font-size: 10px;
    color: #fff;
    background-color: blueviolet;
    margin: 2px;
    border-radius: 10px;
    padding: 2px 10px;
  }
`;
